var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0617 27.6546C21.2007 25.9577 25.9955 21.148 27.6715 15H44.3285C46.0045 21.148 50.7993 25.9577 56.9383 27.6546C56.1849 40.0729 48.5818 51.1251 37.1105 56.2235L36 56.717L34.8895 56.2235C23.4182 51.1251 15.8151 40.0729 15.0617 27.6546ZM27.2929 9C24.7647 9 22.5608 10.7207 21.9476 13.1735C20.8675 17.494 17.494 20.8675 13.1735 21.9476L11.5488 22.3538C10.0509 22.7283 9 24.0742 9 25.6183C9 41.225 18.1911 55.3679 32.4527 61.7064L34.7816 62.7414C35.5573 63.0862 36.4427 63.0862 37.2184 62.7414L39.5473 61.7064C53.8089 55.3679 63 41.225 63 25.6183C63 24.0742 61.9491 22.7283 60.4512 22.3538L58.8265 21.9476C54.506 20.8675 51.1325 17.494 50.0524 13.1735C49.4392 10.7207 47.2353 9 44.7071 9H27.2929ZM47.3426 31.874C48.3776 30.5802 48.1679 28.6923 46.8741 27.6573C45.5803 26.6223 43.6924 26.8321 42.6574 28.1258L32.7512 40.5085L29.1213 36.8786C27.9497 35.707 26.0503 35.707 24.8787 36.8786C23.7071 38.0502 23.7071 39.9497 24.8787 41.1212L30.8787 47.1212C31.4821 47.7246 32.3139 48.0425 33.1659 47.9953C34.0179 47.9481 34.8095 47.5403 35.3426 46.874L47.3426 31.874Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/Policy.c5249fc9.svg";
export { ForwardRef as ReactComponent };